import { Controller } from '@hotwired/stimulus';

export class WorkoutSessionController extends Controller {
    static targets = ['cancelDialog'];

    declare readonly cancelDialogTarget: HTMLDialogElement;
    declare readonly hasCancelDialogTarget: boolean;

    openCancel(event: Event): void {
        event.preventDefault();
        if (this.hasCancelDialogTarget && !this.cancelDialogTarget.open) {
            this.cancelDialogTarget.showModal();
        }
    }

    closeCancel(event: Event): void {
        event.preventDefault();
        this.cancelDialogTarget.close();
    }
}
